import { render } from "./ViewTyreProduct.vue?vue&type=template&id=157b71b2"
import script from "./ViewTyreProduct.vue?vue&type=script&lang=js"
export * from "./ViewTyreProduct.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__